import { Component } from '@angular/core';

@Component({
    selector: 'oc-layout-blank',
    templateUrl: './oc-layout-blank.component.html',
    styles: [':host { display: block; }'],
    standalone: false
})
export class OcLayoutBlankComponent {}
